import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ArrowToFileIcon } from "assets";
import { ViewMoreInfoModal } from "../../modals";

interface ViewMoreInfoButtonProps {
    siteId: number;
}

export const ViewMoreInfoButton = ({ siteId }: ViewMoreInfoButtonProps) => {
    const [isViewMoreInfoModalOpen, setIsViewMoreInfoModalOpen] = useState(false);

    return (
        <>
            <Tooltip arrow placement="top" title="View More Information">
                <IconButton
                    sx={{ width: "24px", height: "24px", padding: "0px" }}
                    onClick={() => setIsViewMoreInfoModalOpen(true)}
                >
                    <ArrowToFileIcon />
                </IconButton>
            </Tooltip>
            <ViewMoreInfoModal
                isOpen={isViewMoreInfoModalOpen}
                onClose={() => setIsViewMoreInfoModalOpen(false)}
                siteId={siteId}
            />
        </>
    );
};
